import React from 'react';
import Loader from "components/atom/Loader";

type PropsType = {
    isLoading: boolean
    keepChildren?: boolean
    useOpacity?: boolean
    children?: React.ReactNode
}

function LoadingContainer(props: PropsType) {
    const {
        isLoading = false,
        keepChildren = false,
        useOpacity = false
    } = props


    if (isLoading || useOpacity) {
        return (
            <div className={keepChildren && isLoading ? 'pointer-events-none relative' : ''}>
                {isLoading && (
                    <div
                        className={`${keepChildren ? 'bg-black-lighter pointer-events-none absolute inset-0 h-full w-full' : ''}`}>
                        <div className={`loading-container ${keepChildren ? 'h-full w-full' : ''}`}>
                            <Loader/>
                        </div>
                    </div>
                )}
                {keepChildren && props.children}
            </div>
        );
    }

    return props.children;
}

export default LoadingContainer;
